import isConfigDefined from 'src/utils/isConfigDefined';

const isTrackingEnabled = () =>
  isConfigDefined()
    ? Boolean(window.ADV_SHOPFRONT_CONFIG.isTrackingEnabled)
    : false;

export default isTrackingEnabled;
